import axios from "axios";

const stacionarApi = axios.create({
    baseURL: "/api-stacionar",
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

stacionarApi.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const stacionarService = {
    async getAnalytics(params = {}) {
        const { data } = await stacionarApi.get("/api/stacionar/analytics", { params });
        return data;
    },

    async getDoctorAnalytics(doctorId, params = {}) {
        const { data } = await stacionarApi.get(`/api/stacionar/analytics/doctor/${doctorId}`, { params });
        return data;
    },

    async getAllEpicrises(params = {}) {
        const { data } = await stacionarApi.get("/api/stacionar/all", { params });
        return data;
    },

    async getEpicrisisDetail(epicrisisId) {
        const { data } = await stacionarApi.get(`/api/stacionar/epicrisis/${epicrisisId}`);
        return data;
    },

    /**
     * Вся история клиники одним JSON-файлом.
     *
     * Отдельный клиент, не stacionarApi: тот настроен на JSON, а здесь
     * приходит файл, и ответ нужен как blob.
     */
    async exportJson(params = {}) {
        const token = localStorage.getItem("token");
        const query = new URLSearchParams(
            Object.entries(params).filter(([, v]) => v !== "" && v != null)
        );

        const res = await fetch(`/api-stacionar/api/stacionar/export/json?${query}`, {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        if (!res.ok) {
            const body = await res.json().catch(() => ({}));
            throw new Error(body?.detail || body?.message || `Ошибка ${res.status}`);
        }

        const disposition = res.headers.get("content-disposition") || "";
        const match = disposition.match(/filename="([^"]+)"/);
        return { blob: await res.blob(), filename: match?.[1] || "stacionar.json" };
    },

    async getHistory(params = {}) {
        const { data } = await stacionarApi.get("/api/stacionar/history", { params });
        return data;
    },
};
